<mat-toolbar>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>

        <a href="#" 
           target="_blank" mat-button class="accent" style="width: 25%;" fxFlex="0 0 auto" fxLayout="row"
           fxLayoutAlign="start center">
           <img src="assets/images/logos/LOGO_YALI_3.png" alt="Yali Logo" width="15%">
            <span class="ml-4">by Bitgob Ideas Con Poder S.A de C.V</span>
        </a>

        <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            <!-- <a mat-button routerLink="/documentation/getting-started/introduction">Documentation</a>
            <span>&bull;</span>
            <a mat-button routerLink="/documentation/changelog">Changelog</a> -->
        </div>

    </div>

</mat-toolbar>